import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { User } from 'lucide-react';
import NotificationIcon from './NotificationIcon';

const Navbar = () => {
  const { user } = useAuth();

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-brand">
          <h1 style={{ 
            margin: 0, 
            fontSize: '20px', 
            fontWeight: 'bold', 
            color: 'white' 
          }}>
            Farmácia Popular de Minas
          </h1>
        </div>
        
        <div className="navbar-nav">
          <NotificationIcon />
          <div className="nav-link" style={{ cursor: 'default' }}>
            <User size={18} />
            {user?.nome} ({user?.cargo})
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;